import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Observable} from "rxjs";
import {ProleisObject} from "proleis-rest-client";

@Component({
  selector: 'p4m-complete-tracking',
  templateUrl: './complete-tracking.component.html',
  styleUrls: ['./complete-tracking.component.scss']
})
export class CompleteTrackingComponent {
  @Input()
  isEmployee = true;

  @Input()
  ratingTypes$: Observable<ProleisObject[]>;
  selectedRatingType: ProleisObject | undefined;

  @Input()
  servicesTypes$: Observable<ProleisObject[]>;
  selectedServiceType: ProleisObject | undefined;

  @Output()
  trackingChanged = new EventEmitter<TrackingData>();

  comment = '';

  onTrackingChanged() {
    this.trackingChanged.emit({
      ratingTypeId: this.selectedRatingType?.OBJECT_ID,
      serviceTypeId: this.selectedServiceType?.OBJECT_ID
    })
  }
}

export interface TrackingData {
  serviceTypeId: number;
  ratingTypeId: number;
}
